(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-gift-card"]) return;
  try {
    
document.addEventListener('change',function(event){if(event.target.matches('[data-wm-handwriting]'))event.target.closest('.wm-gc-issued').dataset.handwriting=String(event.target.checked);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-compact-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wm-compact-reviews')) {
  customElements.define('wm-compact-reviews', class extends HTMLElement {
    connectedCallback() {
      this.toggleLink = this.querySelector('.wm-reviews__toggle');
      this.body = this.querySelector('.wm-reviews__body');
      this.dots = this.querySelector('.wm-reviews__dots');
      this.prev = this.querySelector('.wm-reviews__prev');
      this.next = this.querySelector('.wm-reviews__next');
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.toggleLink.addEventListener('click', event => {
        if (!this.list) return;
        event.preventDefault();
        this.setExpanded(!this.classList.contains('is-expanded'));
      }, options);
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      document.addEventListener('click', event => {
        if (event.target.closest('.jdgm-preview-badge, a[href="#judgeme_product_reviews"], a[href="#shopify-product-reviews"]')) this.setExpanded(true);
      }, options);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.body, {childList:true,subtree:true});
      this.resize = new ResizeObserver(() => this.updateDots());
      this.resize.observe(this);
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.resize?.disconnect();
      this.abort?.abort();
    }
    sync() {
      const widget = this.body.querySelector('.jdgm-rev-widg');
      const list = this.body.querySelector('.jdgm-rev-widg__reviews');
      if (!widget || !list || !list.querySelector('.jdgm-rev')) return;
      const summary = this.querySelector('.wm-reviews__rating');
      const stars = widget.querySelector('.jdgm-rev-widg__summary-stars');
      const rating = widget.dataset.averageRating;
      const countText = widget.querySelector('.jdgm-rev-widg__summary-text')?.textContent?.trim();
      const signature = rating + countText;
      if (summary.dataset.signature !== signature && stars) {
        const starCopy = stars.cloneNode(true);
        starCopy.querySelectorAll('a, .jdgm-rev-widg__summary-average').forEach(el => el.remove());
        const label = document.createElement('span');
        label.textContent = [rating, countText].filter(Boolean).join(' · ');
        summary.replaceChildren(starCopy, label);
        summary.dataset.signature = signature;
      }
      if (this.list !== list) {
        this.list = list;
        list.addEventListener('scroll', () => this.updateCurrent(), {passive:true,signal:this.abort.signal});
      }
      if (!this.classList.contains('is-expanded')) this.setExpanded(false);
      this.updateDots();
    }
    setExpanded(expanded) {
      this.classList.toggle('is-expanded', expanded);
      this.classList.toggle('is-compact', !expanded);
      this.toggleLink.setAttribute('aria-expanded', String(expanded));
      this.toggleLink.textContent = expanded ? this.toggleLink.dataset.closeLabel : this.toggleLink.dataset.openLabel;
      this.updateDots();
    }
    metrics() {
      if (!this.list) return {step:1,max:0};
      const card = this.list.querySelector('.jdgm-rev');
      const step = (card?.getBoundingClientRect().width || 1) + 16;
      return {step,max:Math.max(0,Math.round((this.list.scrollWidth-this.list.clientWidth)/step))};
    }
    move(delta) {
      const {step,max} = this.metrics();
      const position = Math.max(0,Math.min(max,Math.round(this.list.scrollLeft/step)+delta));
      this.list.scrollTo({left:position*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    updateDots() {
      if (!this.list) return;
      const {max} = this.metrics();
      const expanded = this.classList.contains('is-expanded');
      this.prev.hidden = this.next.hidden = expanded || max === 0;
      const count = expanded || max === 0 ? 0 : max+1;
      if (this.dots.children.length !== count) {
        this.dots.replaceChildren();
        for (let i=0;i<count;i++) {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', this.dataset.slideLabel+' '+(i+1));
          button.addEventListener('click', () => {
            const {step} = this.metrics();
            this.list.scrollTo({left:i*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
          });
          this.dots.append(button);
        }
      }
      this.updateCurrent();
    }
    updateCurrent() {
      const {step,max} = this.metrics();
      const index = Math.round((this.list?.scrollLeft || 0)/step);
      Array.from(this.dots.children).forEach((dot,i) => dot.setAttribute('aria-current',String(i===index)));
      this.prev.disabled = index <= 0;
      this.next.disabled = index >= max;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-home-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
 const link = event.target.closest('a[href="#wm-home-fabric"]');
 if (!link) return;
 const target = document.getElementById('wm-home-fabric');
 if (!target) return;
 event.preventDefault();
 event.stopPropagation();
 const header = document.querySelector('.page-header');
 const offset = (header ? header.getBoundingClientRect().height : 0) + 20;
 const heading = target.querySelector('h2');
 if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({preventScroll:true}); }
 window.scrollTo({top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-home-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
 const update = () => {
  const rating = document.querySelector('.wm-home-reviews .jdgm-all-reviews-rating');
  const count = document.querySelector('.wm-home-reviews [data-number-of-reviews]');
  if (!rating || !count) return;
  const score = Number(rating.dataset.score), number = Number(count.dataset.numberOfReviews);
  if (!(score > 0 && score <= 5 && number > 0)) return;
  const summary = score.toFixed(2) + '/5 from ' + number.toLocaleString(document.documentElement.lang || 'en-AU') + ' reviews';
  const summaryLink = count.querySelector('a');
  if (summaryLink && summaryLink.textContent !== summary) summaryLink.textContent = summary;
  document.querySelectorAll('[data-wm-review-summary]').forEach(el => {
   const text = el.dataset.template.replace('__SCORE__', score.toFixed(2)).replace('__COUNT__', number.toLocaleString(document.documentElement.lang || 'en-AU'));
   if (el.textContent !== text) el.textContent = text;
  });
 };
 update();
 new MutationObserver(update).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['data-score','data-number-of-reviews']});
 document.addEventListener('shopify:section:load', update);
})();

  } catch(e) { console.error(e); }
})();
})();
